import { AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode } from './../../../../../api/models/ace/xFound/Portal/Core/Entities/ace-ausschreibung-ace-ausschreibung-enums-ace-ausschreibung-statuscode';
import { Component, ErrorHandler, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { AnfrageService, AusschreibungService } from '@/api/service-index';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { GlobalEnumsAceXfoundportalobjekt } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';
import { PortalContextService } from '@/core/services/portal-context.service';
import { AusschreibungDisplayModel } from '@/api/model-index';
import { I18nService } from '@/core/services/i18nService';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { DocumentSelectionDialogComponent, UnterlagenDialogResult } from '../../../../components/document/document-selection-dialog/document-selection-dialog.component';
import { DocumentService } from '@/core/services/document.service';
import { Constants } from '@/constants';

@Component({
  selector: 'ausschreibung-card',
  templateUrl: './ausschreibung-card.component.html',
  styleUrls: ['./ausschreibung-card.component.scss']
})
export class AusschreibungCardComponent {
  @Input() public ausschreibung: AusschreibungDisplayModel;

  protected unterlagenDialog: DialogRef;

  public get isProjektbeschreibungVisible(): boolean {
    return this.ausschreibung != null && this.ausschreibung.goalDescription != null && this.getGoalDescriptionText(this.ausschreibung).length > 0;
  }

  public get isNoDescriptionMessageVisible(): boolean {
    return !this.isProjektbeschreibungVisible;
  }

  public get isOpen(): boolean {
    return this.ausschreibung.ausschreibungsStatus == AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.InDurchfuhrung && 
    (moment(Date.now()).isBetween(moment(this.ausschreibung.dateFrom), moment(this.ausschreibung.dateTo), "day", "[]"));
  }

  public get isPermanentOpen(): boolean {
    return this.ausschreibung.ausschreibungsStatus == AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.InDurchfuhrung && 
    (moment(Date.now()).isSameOrAfter(moment(this.ausschreibung.dateFrom), "day")) &&
    this.ausschreibung.dateTo == null;
  }

  public get isExpired(): boolean {
    return !this.isOpen;
  }

  public get isNotYetOpen(): boolean{
    return !this.isOpen && !this.isPermanentOpen && (moment(Date.now()).isBefore(moment(this.ausschreibung.dateFrom), "day"));
  }

  public get isCreateButtonDisabled(): boolean {
    return this.isExpired && !this.isPermanentOpen;
  }

  constructor(protected router: Router,
    protected route: ActivatedRoute, 
    protected anfrageService: AnfrageService, 
    protected loadingAnimationService: LoadingAnimationService, 
    protected errorHandler: ErrorHandler,
    protected portalContextService: PortalContextService,
    public languageService: I18nService, 
    public ausschreibungService: AusschreibungService, 
    public dialogService: DialogService, 
    public documentService: DocumentService)
  {
  }

  public onCreateClick() {
    this.createAnfrage(this.ausschreibung.phase?.portalObject);
  }

  public getGoalDescriptionText(ausschreibung: AusschreibungDisplayModel): string {
    return this.languageService.getCurrentLocalizedTextDisplayModel(ausschreibung.goalDescription)?.text ?? "";
  }

  public createAnfrage(itemScope: GlobalEnumsAceXfoundportalobjekt | undefined) {
    if (this.ausschreibung.ausschreibungsNummer) {
      let scope: GlobalEnumsAceXfoundportalobjekt = itemScope ?? this.ausschreibung.portalObject as unknown as GlobalEnumsAceXfoundportalobjekt;

      let subscription = this.anfrageService.apiAnfrageScopePost({ scope: scope, body: JSON.stringify(this.ausschreibung.ausschreibungsNummer) })
        .subscribe(anfrageId => {
          this.portalContextService.Anfragen = null;

          this.router.navigate(['../', 'anfrage', 'detail', scope, anfrageId], { relativeTo: this.route });
        }, (error) => {
          this.errorHandler.handleError(error);
          this.loadingAnimationService.hide();
        });

      this.loadingAnimationService.donNotHide().showSpinnerUsingSubscription(subscription);
    }
  }

  public isLogoVisible(ausschreibung: AusschreibungDisplayModel): boolean {
    return ausschreibung.logo != null;
  }

  public getButtonText(): string {
    return this.languageService.instant("tender.apply") + " " + this.ausschreibung.name;
  }

  public getLogo(ausschreibung: AusschreibungDisplayModel): string {
    return 'data:image/jpg;base64,' + ausschreibung.logo;
  }

  public openUnterlagenDialog(nummer: any) {
    let subscription = this.ausschreibungService.apiAusschreibungAusschreibungNummerAllUnterlagenGet({ AusschreibungNummer: nummer })
    .subscribe(response => {
      this.unterlagenDialog = this.dialogService.open({
        content: DocumentSelectionDialogComponent,
        maxWidth: Constants.DIALOG.MAX_WIDTH,
        maxHeight: Constants.DIALOG.MAX_HEIGHT,
        title: this.languageService.instant("ausschreibung.unterlagen.dialog-title")
      });
  
      let dialogComponent: DocumentSelectionDialogComponent = this.unterlagenDialog.content.instance;
      dialogComponent.documents = response;
  
      this.unterlagenDialog.result.subscribe(result => {
        this.onUnterlagenDialogClose(<UnterlagenDialogResult>result, nummer);
      });
    });
    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }

  protected onUnterlagenDialogClose(result: UnterlagenDialogResult, ausschreibungsnummer: string) {
    if (!result.documentsToDownload || result.documentsToDownload.length < 1)
      return;

    let documentIds: string[] = result.documentsToDownload.map(document => document.documentId+"");

    let subscription = this.ausschreibungService.apiAusschreibungAusschreibungNummerUnterlagenGet({ AusschreibungNummer: ausschreibungsnummer, documentIds: documentIds })
      .subscribe(response => {
        response.forEach(file => this.documentService.download(file));
    })
    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }
}
